import { DashboardShell } from "@/components/dashboard-shell";
import { CustomersOverview } from "@/components/customers/customers-overview";
import { createFileRoute } from "@tanstack/react-router";
import {
  RouteLoading,
  ToolbarSkeleton,
  CardGridSkeleton,
} from "@/components/route-loading";

export const Route = createFileRoute("/customers/")({
  component: CustomersPage,
  head: () => ({ meta: [{ title: "Customers" }] }),
  pendingComponent: CustomersPending,
});

function CustomersPage() {
  return (
    <DashboardShell>
      <CustomersOverview />
    </DashboardShell>
  );
}

// Shown while this route's chunk (and the ReUI components in it)
// downloads. Was src/app/customers/loading.tsx.
function CustomersPending() {
  return (
    <RouteLoading>
      <ToolbarSkeleton />
      <CardGridSkeleton />
    </RouteLoading>
  );
}
